<template>
    <div>
      <div class="white-section">
        <b-form @submit.prevent class="mt-0">
        <b-row>
            <b-col md="4">
            <label style="margin-bottom:20px !important" for="selected-date">تاریخ</label>
            <my-ab-date-picker
                  :ref="selectedDate ? selectedDate.toString() : 'selected-date'"
                  :type="'date'"
                  :locale="'fa,en'"
                  click-on="all"
                  :clearable="false"
                  :show="false"
                  :auto-submit="true"
                  :column="1"
                  v-model="selectedDate"
                  :toIso="true"
                  :custom-hour="23"
                  id="selected-date"
                  >
                </my-ab-date-picker>
          </b-col>
          <b-col md="4">
            <b-form-group :label="$t('holiday.descriptionCalendar')" label-for="holiday-desc" >
                <textarea
                    name=""
                    v-model="descriptionCalendar"
                    id="holiday-desc"
                    class="form-control"
                    style="min-height: 100px"
                ></textarea>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group :label="$t('holiday.descriptionCenter')" label-for="holiday-description" >
                <textarea
                    name=""
                    v-model="descriptionCenter"
                    id="holiday-description"
                    class="form-control"
                    style="min-height: 100px"
                ></textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end">
            <b-button
            size=""
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="info"
            @click="editHoliday"
        >
            {{ $t("general.submit") }}
        </b-button>
        </div>
        </b-form>
      </div>
    </div>
</template>
  
  <script>
  import { mapGetters } from "vuex";
  import { required } from "vuelidate/lib/validators";
  import Ripple from "vue-ripple-directive";
  import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";

  import {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BBreadcrumb,
    BFormInvalidFeedback
  } from "bootstrap-vue";
  import ToastificationContent from "@core/components/toastification/ToastificationContent";
  export default {
    data() {
      return {
        selectedDate:"",
        descriptionCenter:"",
        descriptionCalendar:"",
      }
    },
    mounted() {
      const id = this.$route.params.id
      this.$store.dispatch('holiday/findHoliday',id).then((res)=>{
        this.selectedDate= res.date
        this.descriptionCenter=res.descriptionCenter
        this.descriptionCalendar=res.descriptionCalendar
      });
    },
    directives: {
      Ripple,
    },
    components: {
      BRow,
      BCol,
      BFormGroup,
      BFormInput,
      BForm,
      BButton,
      BFormInvalidFeedback,
      BBreadcrumb,
      MyAbDatePicker
    },
    validations() {
      return {
        holidayToEdit: {
          selectedDate: {
            required,
          },
          descriptionCenter:{
            required
          },
          descriptionCalendar:{
            required
          }
        }
      };
    },
    methods: {
      editHoliday() {
        if(this.selectedDate){
          const payload = {
            date: this.selectedDate,
            descriptionCenter: this.descriptionCenter,
            descriptionCalendar: this.descriptionCalendar,
            status:"active"
          };
        this.$v.$touch();
          this.$store.commit('SET_IS_LOADING', true)
          this.$store
              .dispatch("holiday/UpdateHoliday", {
                id: this.$route.params.id,
                payload: payload,
              })
              .then((res) => {
                this.$store.commit('SET_IS_LOADING', false)
                this.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
                  title: this.$t('toastification.success'),
                  variant: 'success',
                  solid: true,
                });
                localStorage.getItem('showHoliday')
                localStorage.getItem('hideCalendar')
                console.log(localStorage.getItem('showHoliday') , 'lkk')

                this.$router.push({name: "manageHolidays"});
              })
              .catch((error) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('toastification.failedAction'),
                    content: this.$t('toastification.failedAction'),
                    icon: 'EditIcon',
                    variant: 'danger',
                  },
                })
                this.$store.commit('SET_IS_LOADING', false)
              });
            }else{
              this.$bvToast.toast(this.$t('toastification.dateNotSelected'), {
                  title: this.$t('toastification.error'),
                  variant: 'danger',
                  solid: true,
                });
            }
      },
    },
    created() {
      this.pushBreadcrumb({text: 'editHoliday', to:{name:'editHoliday' }, translate:true})
      this.setCurrentBreadcrumb([{text: 'editHoliday', to:{name:'editHoliday' }, translate:true}])
    },
  };
  </script>